import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { ImpuestoService } from '../../../services/ImpuestoService';
import { Validators } from '../../../components/CatalogForm/validators';

const formFields = [
  {
    name: 'impuesto',
    label: 'Clave',
    type: 'text',
    col: 3,
    placeholder: 'Ej. IVA16',
    validators: [
      Validators.required("La clave es obligatoria")
    ],
  },
  {
    name: 'impuesto_nombre',
    label: 'Nombre',
    type: 'text',
    col: 6,
    placeholder: 'Ej. IVA Trasladado 16%',
    validators: [
      Validators.required("El nombre es obligatorio")
    ],
  },
  {
    name: 'impuesto_porcentaje',
    label: 'Porcentaje (%)',
    type: 'number',
    col: 3,
    placeholder: '16',
    validators: [
      Validators.required("El porcentaje es obligatorio"),
      Validators.number()
    ],
  },
  {
    name: 'impuesto_tipo',
    label: 'Tipo',
    type: 'text',
    col: 4,
    placeholder: 'Ej. Trasladado',
    validators: [
      Validators.required("El tipo es obligatorio")
    ],
  },
  {
    name: 'impuesto_sat_cve',
    label: 'Clave SAT',
    type: 'text',
    col: 4,
    placeholder: 'Ej. 002',
    validators: [
      Validators.required("La clave SAT es obligatoria")
    ],
  },
  {
    name: 'impuesto_factor',
    label: 'Factor',
    type: 'text',
    col: 4,
    placeholder: 'Ej. Tasa',
    validators: [
      Validators.required("El factor es obligatorio")
    ],
  },
];

export const ImpuestoForm = () => {
  const { id } = useParams();

  const handleLoadData = async (recordId) => {
    return await ImpuestoService.obtenerPorId(recordId);
  };

  const handleSubmit = async (values) => {
    return await ImpuestoService.guardar(values);
  };

  return (
    <CatalogForm
      title="Impuesto"
      subtitle="Tasas, cuotas y factores impositivos"
      fields={formFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/Impuestos"
    />
  );
};

export default ImpuestoForm;
